/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbListClassAttributesResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbListClassAttributesResponse.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbListClassAttributesResponse>): ServiceNowCmdbListClassAttributesResponse {
        let obj = Object.assign(new ServiceNowCmdbListClassAttributesResponse(), model);
        ServiceNowCmdbListClassAttributesResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbListClassAttributesResponse>): ServiceNowCmdbListClassAttributesResponse {
        if (!model) return null;
        return ServiceNowCmdbListClassAttributesResponse.newInstance(<ServiceNowCmdbListClassAttributesResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbListClassAttributesResponse) {
        if (!obj) return;

        models.ServiceNowCmdbListClassAttributesResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbListClassAttributesResponse): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbListClassAttributesResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let val of this.results) {
                models.ServiceNowCmdbCiClassAttribute.fixupPrototype(val);
            }
        }
    }

    /**
     * List of Cmdb CI Class Attributes
     */
    results: Array<models.ServiceNowCmdbCiClassAttribute>;

}
